<template>
  <div class="operate">
    <div class="cf">
      <el-radio-group @change="changeState()" size="mini" v-model="state" style="margin: 10px" :disabled="loading">
        <el-radio-button label="0">日</el-radio-button>
        <el-radio-button label="1">月</el-radio-button>
      </el-radio-group>
      <el-date-picker v-model="data.valueTime" type="month" placeholder="选择月份" :clearable="false" value-format="yyyy-MM"
        @change="dateValue()" v-if="state === '1'" style="width: 140px; margin: 0 10px 10px 10px" size="mini">
      </el-date-picker>
      <el-date-picker v-model="data.valueTime" type="date" placeholder="选择日期" :clearable="false"
        value-format="yyyy-MM-dd" @change="dateValue()" v-if="state === '0'"
        style="width: 140px; margin: 0 10px 10px 10px" size="mini">
      </el-date-picker>
    </div>
    <div style="height: 89%;" v-loading="loading">
      <iframe ref="Iframe" :src="src" frameborder="0" width="100%" height="100%" :name="name"></iframe>
    </div>
  </div>
</template>
<script>
import XEUtils from 'xe-utils'

export default {
  name: "order_share",
  data() {
    return {
      src: "",
      name: "客户分账明细",
      data: {
        valueTime: ""
      },
      loading: false,
      state: '0'
    };
  },
  mounted() {
    this.state = '0'
    const time = XEUtils.toDateString(new Date(), 'yyyy-MM-dd')
    this.$set(this.data, 'valueTime', time)
    this.$nextTick(() => {
      this.dateValue()
    })
    this.$validate.ToDocumentTitle()
  },
  methods: {
    changeState() {
      if (this.state === '0') {
        const time = XEUtils.toDateString(new Date(), 'yyyy-MM-dd')
        this.$set(this.data, 'valueTime', time)
      } else {
        const time = XEUtils.toDateString(new Date(), 'yyyy-MM')
        this.$set(this.data, 'valueTime', time)
      }
      this.dateValue()
    },
    dateValue() {
      if (!['', null, undefined].includes(this.data.valueTime)) {
        let token = localStorage.getItem('token')
        this.loading = true
        this.src = "";
        this.src = `https://platform.wechain360.com/ureport/preview?_u=db:order_share.ureport.xml&date=${this.data.valueTime}&math=${Math.random()}&token=${token}`;
        const iframe = this.$refs.Iframe;
        if (iframe.attachEvent) {
          iframe.attachEvent("onload", () => {
            this.loading = false;
          });
        } else {
          iframe.onload = () => {
            this.loading = false;
          };
        }
      } else {
        this.$message.warning("请选择时间");
      }
    }
  }
}
</script>
<style>
.operate {
  padding: 20px;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.cf {
  overflow: hidden;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.background-blue {
  width: 100%;
  margin: 10px 0;
  background: #66ccff;
  padding: 5px 10px;
  box-sizing: border-box;
  text-align: center;
  font-weight: bold;
}
</style>
